import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'; // import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
// import CheckBoxIcon from '@material-ui/icons/CheckBox'

import i18n from 'i18next';
var gt = i18n.getFixedT(null, 'app'); // const icon = <CheckBoxOutlineBlankIcon color='primary' fontSize="small" />
// const checkedIcon = <CheckBoxIcon color='primary' fontSize="small" />

/** 
 * A React Card Component
 * @constructor
 * @param {string} [id] - Container dom element #id
 * @param {string} [className] - Container dom element .class
 * @param {string} [width] - Container dom width.
 * @param {function} [onChange] - Callback function when value is chandged.
 * @param {array} [options] - It's selector's options.
 * @param {string} [inputPlaceholder] - It's a placeholder string at input.
 * @param {string} [selectAllLabel] - If selectAllLabel have string value, enable select all function.
 * @param {boolean} [disabled] - The param is used to switch component enable status.
 * 
 * options format: [{value: xxx, text:xxx}]
 * 
 * 
*/

var MultipleSelector = /*#__PURE__*/React.memo(function (props) {
  var id = props.id,
      onChange = props.onChange,
      className = props.className,
      width = props.width,
      options = props.options,
      inputPlaceholder = props.inputPlaceholder,
      value = props.value,
      selectAllLabel = props.selectAllLabel,
      disabled = props.disabled;
  var cloneValue = [];

  if (value.length > 0) {
    _.forEach(options, function (el) {
      if (_.some(value, function (o) {
        return o.value === el.value;
      })) cloneValue.push(el);
    });
  }

  var _useState = useState(cloneValue),
      _useState2 = _slicedToArray(_useState, 2),
      newValue = _useState2[0],
      setNewValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var total = useRef(options.length);

  var handleChangeValue = function handleChangeValue(newValue) {
    var selectedAllAry = _.find(newValue, function (el) {
      return el.value === 'selectAll';
    });

    if (!_.isEmpty(selectedAllAry)) {
      setNewValue(options);
      if (onChange) onChange(options);
      return;
    }

    setNewValue(newValue);
    if (onChange) onChange(newValue);
  }; // const filterOptions = createFilterOptions({
  //     matchFrom: 'any',
  //     limit: 10,
  // })


  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: className
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    disabled: disabled,
    multiple: true,
    disableCloseOnSelect: true,
    id: "checkboxes-tags-demo-".concat(id),
    value: newValue,
    onChange: function onChange(event, newValue) {
      return handleChangeValue(newValue);
    },
    options: options,
    getOptionLabel: function getOptionLabel(option) {
      return option.text;
    } // filterOptions={filterOptions}
    // open={true}
    ,
    renderOption: function renderOption(option, _ref) {
      var selected = _ref.selected;
      return /*#__PURE__*/React.createElement("span", null, option.text);
    },
    inputValue: inputValue,
    noOptionsText: gt('global.lbl-no-option'),
    onInputChange: function onInputChange(_, newInputValue) {
      setInputValue(newInputValue);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        title: params.inputProps.value,
        placeholder: inputPlaceholder
      }));
    }
  }));
});
MultipleSelector.defaultProps = {
  id: 'c-multiple-selector',
  width: '200px',
  inputPlaceholder: '',
  selectAllLabel: '',
  disabled: false
};
MultipleSelector.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  inputPlaceholder: PropTypes.string,
  selectAllLabel: PropTypes.string,
  disabled: PropTypes.bool
};
export default MultipleSelector;